import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
interface FeatureListProps {
  items: string[];
}
export function FeatureList({
  items
}: FeatureListProps) {
  return <div className="space-y-4 my-8" data-id="element-7">
      {items.map((item, index) => <div key={index} className="flex gap-3 items-start" data-id="element-8">
          <CheckCircle2Icon className="w-6 h-6 text-[#D4AF37] flex-shrink-0 mt-0.5" data-id="element-9" />
          <p className="text-[#3A3226] leading-relaxed" data-id="element-10">{item}</p>
        </div>)}
    </div>;
}